import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import am4geodata_worldHigh from '@amcharts/amcharts4-geodata/worldHigh';

const projectValuesQuery = '[data-projects-values]';
const projectValuesKey = 'projects-values';

const fastTravelCountries = '[data-fasttravel-map-countries]';
const fastTravelCountriesKey = 'fasttravel-map-countries';

const displayCountryDetailQuery = '[data-display-country-detail]';
const displayCountryDetailKey = 'display-country-detail';
var displayCountryDetail: string;

var allFastTravelCountries: MapCountryItem[];
var chart: am4maps.MapChart;

var ProjectsTitle: MapProjectItem[];
var NdcMatchmakerMapScope;
var FastTravelMapDDL;

class CountryItem {
    value: string;
    name: string;
    id: string;
    fill: am4core.Color;
    customdata: string;
    isocode: string;
}

class FastTravelGroup {
    project: string;
    countries: CountryItem[];
}

class MapCountryItem {
    IsoCode: string;
    Name: string;
    Id: string;
    Project: string;
    Status: string;
    CustomData: string;
    Fill: string;
}

interface MapProjectItem {
    project: string;
}

function parseObject(value: any) {
	try {
		return JSON.parse(decodeHtml(value));
	} catch(e){
		return false;
	}	
}

function decodeHtml(value: any): string {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = value;
    return textArea.value;
}

am4core.ready(function () {
	try {
		//Get Scope
		NdcMatchmakerMapScope = $('#fastTravelMap');
		FastTravelMapDDL = $('#fastTravelMapDDL');

		// Load all IATA fast travel countries to include in maps.
		var countries = $(document).find(fastTravelCountries).data(fastTravelCountriesKey);
		allFastTravelCountries = parseObject(countries);

		//Get Projects
		var projects = $(document).find(projectValuesQuery).data(projectValuesKey);
		ProjectsTitle = parseObject(projects);

		//Load all country
		chart = am4core.create('fastTravelMapdiv', am4maps.MapChart);
		chart.geodata = am4geodata_worldHigh;
		chart.responsive.enabled = true;

		//Display Country Details or not
		displayCountryDetail = $(document).find(displayCountryDetailQuery).data(displayCountryDetailKey);

		// Set projection
		chart.projection = new am4maps.projections.Miller();

		// home button
		var buttonHome = chart.chartContainer.createChild(am4core.Button);
		buttonHome.icon = new am4core.Sprite();
		buttonHome.icon.path = 'M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8';
		buttonHome.padding(6, 5, 6, 5);
		buttonHome.width = 45;
		buttonHome.align = 'left';
		buttonHome.marginRight = 15;
		buttonHome.events.on('hit', function () {
			chart.goHome();
		});

		loadMap(NdcMatchmakerMapScope);

		//Create event on DDL to refresh Map group
		FastTravelMapDDL.change(function () {
			loadMap(NdcMatchmakerMapScope);
		});
	} catch(e){
		console.warn('TravelMap initialization was not successful');
		return false;
	}	
});

function loadMap(scope: JQuery<HTMLElement>) {
    chart.series.clear();
    chart.closeAllPopups();
    var excludedCountries = ['AQ'];

    var groups: FastTravelGroup[] = [];
    if (allFastTravelCountries.length > 0) {
        ProjectsTitle.forEach((project: string) => {
            var newGroup = new FastTravelGroup();
            newGroup.project = project;
            newGroup.countries = [];

            allFastTravelCountries.forEach((country) => {
                var projectName = country.Project.toLowerCase();
                if (projectName == newGroup.project.toLowerCase()) {
                    var countryItem = new CountryItem();
                    countryItem.id = country.Id;
                    countryItem.name = country.Title;
                    countryItem.fill = am4core.color(country.Fill);
                    countryItem.customdata = country.CustomData;
                    countryItem.isocode = country.IsoCode;
                    countryItem.id = country.IsoCode;
                    newGroup.countries.push(countryItem);
                }
            });
            groups.push(newGroup);
        });
    }

    // Create a series for each group, and populate the above array
    groups.forEach((group) => {
        var selectedProject = FastTravelMapDDL.find(':selected').text();

        if (selectedProject == group.project) {
            var series = chart.series.push(new am4maps.MapPolygonSeries());
            series.name = group.project;
            series.useGeodata = true;
            series.setStateOnChildren = true;
            series.calculateVisualCenter = true;

            var includedCountries = [];
            group.countries.forEach(function (country) {
                includedCountries.push(country.isocode);
            });

            series.include = includedCountries;

            // change all country color
            series.events.on('datavalidated', function () {
                series.mapPolygons.each(function (polygon, index) {
                    var data = polygon.dataItem.dataContext;
                    var country = allFastTravelCountries.find(
                        (x) => x.IsoCode == data.id && x.Project.toLowerCase() == group.project.toLowerCase(),
                    );
                    polygon.fill = am4core.color(country.Fill);
                });
            });

            var mapPolygonTemplate = series.mapPolygons.template;
            mapPolygonTemplate.fillOpacity = 0.8;
            mapPolygonTemplate.tooltipText = '{name}';
            mapPolygonTemplate.nonScalingStroke = true;
            mapPolygonTemplate.strokeWidth = 0.5;

            // change color effect on hover...
            var hs = mapPolygonTemplate.states.create('hover');
            hs.properties.fillOpacity = 0.5;

            mapPolygonTemplate.events.on('hit', function (event) {
                chart.closeAllPopups();
                if (displayCountryDetail.toLowerCase() == 'true') {
                    var data = event.target.dataItem.dataContext;

                    var details = allFastTravelCountries.find((x) => x.IsoCode == data.id).CustomData;
                    if (details) {
                        chart.openPopup(details, 'Details');
                    }
                }
            });

            series.data = JSON.parse(JSON.stringify(group.countries));
        }
    });
}
